import { createPortal } from 'react-dom';
import React, {
  Fragment,
  useState,
  useEffect,
  useContext,
  useCallback,
  useRef,
} from 'react';
import {
  withStyles,
  Grid,
  Drawer,
  Divider,
  Dialog,
  DialogContent,
  DialogActions,
} from '@material-ui/core';
import Close from '../../asset/img/icon_close.svg';
import WeekView from './WeekView';
import ReserveNoDate from './ReserveNoDate';
import { postExtV2, postSmileExt } from '../data/DataLoader';
import Snackbar from '@material-ui/core/Snackbar';
import DataContext from '../data/DataContext';
import { openLink } from '../util/utilNative';
import Loading from '../page/Loading';
import EmblaCarouselReact from 'embla-carousel-react';

const styles = (theme) => ({
  root: {
    position: 'relative',
    maxWidth: '100%',
    width: '100%',
  },
  drawerContainer: {
    width: '100%',
    position: 'fixed',
    zIndex: '1300',
    inset: '0',
  },
  drawerFrame: {
    borderRadius: '0.625rem',
    borderBottomRightRadius: 0,
    borderBottomLeftRadius: 0,
    height: '80%',
    overflowY: 'auto',
    transform: 'none',
    transition: 'transform 225ms cubic-bezier(0, 0, 0.2, 1)',
    top: 'auto',
    left: '0',
    right: '0',
    bottom: '0',
    maxHeight: '100%',
    display: 'flex',
    zIndex: '1200',
    position: 'fixed',
    overflowY: 'auto',
    flexDirection: 'column',
    boxShadow:
      '0px 8px 10px -5px rgba(0, 0, 0, 0.2), 0px 16px 24px 2px rgba(0, 0, 0, 0.14), 0px 6px 30px 5px rgba(0, 0, 0, 0.12)',
    color: 'rgba(0, 0, 0, 0.87)',
    backgroundColor: '#fff',
  },
  drawerRoot: {
    display: 'flex',
    flexDirection: 'column',
    overflowY: 'hidden',
  },
  dialogContainerBackdrop: {
    opacity: '1',
    transition: 'opacity 225ms cubic-bezier(0.4, 0, 0.2, 1)',
    top: '0',
    left: '0',
    right: '0',
    bottom: '0',
    display: 'flex',
    zIndex: '-1',
    position: 'fixed',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
  },
  dividerTitle: {
    height: '0.0625rem',
    background: '#000',
    margin: '0rem 1rem 1.2188rem 1rem',
  },
  titleCloseTop: {
    fontFamily: 'inherit',
    fontSize: theme.font.size18,
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '1.33',
    letterSpacing: 'normal',
    textAlign: 'left',
    color: '#000',
    width: '100%',
    padding: '0.0625rem 0rem',
  },
  closeTop: {
    display: 'flex',
    justifyContent: 'end',
    '& img': {
      width: '1.5rem',
      height: '1.5rem',
    },
    border: 'none',
    background: 'none',
  },
  drawerHeaderCloseTop: {
    display: 'flex',
    minHeight: 'auto:', //"2.875rem",
    justifyContent: 'space-between',
    alignItems: 'center',
    // padding: "1rem",
    padding: '1rem 1rem 0.5rem 1rem',
    flexDirection: 'row',
  },
  componentWrapper: {
    overflowY: 'auto',
  },
  modalFooter: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: ' 0.875rem 1rem',
    marginTop: '1rem',
    placeContent: 'center',
    borderTop: '0.0625rem solid #ddd',
  },
  modalButton: {
    width: '100%',
    height: '3.125rem',
    borderRadius: '0.375rem',
    border: 'solid 0.0625rem #ddd',
    backgroundColor: '#fff',
    // margin: "0rem 0.25rem",
    fontFamily: 'NotoSansKR',
    fontSize: '0.875rem',
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '1.43',
    letterSpacing: 'normal',
    textAlign: 'center',
    color: '#000',
  },
  modalButtonLeft: {
    paddingRight: '0.25rem',
  },
  modalButtonRight: {
    paddingLeft: '0.25rem',
  },
  modalButtonDefault: {
    color: '#bbb',
    backgroundColor: '#999',
    border: '0rem',
  },
  modalButtonStrong: {
    color: '#fff',
    backgroundColor: '#ea1917', //"#da0f47",
    border: '0rem',
    fontWeight: 'bold',
  },
  modalGridContainer: {},
  modalGridItemLabel: {
    padding: '0.75rem 1rem 0rem 1rem',
  },
  modalGridItemLabelFirst: {
    padding: '0rem 1rem',
  },
  modalGridItem: {
    padding: '0.75rem 1rem',
  },
  modalLabel: {
    // minHeight: "1.25rem",
    display: 'flex',
    fontFamily: 'NotoSansKR',
    fontSize: theme.font.size15,
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '1.2',
    letterSpacing: 'normal',
    textAlign: 'left',
    color: '#000',
    paddingBottom: '0.75rem',

    '& .star': {
      fontSize: theme.font.size14,
      color: '#ea1917', //"#da0f47"
    },
  },
  modalLabelDesc: {
    paddingBottom: '0.75rem',
    fontSize: theme.font.size12,
    fontWeight: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '1.5',
    letterSpacing: 'normal',
  },
  modalField: {
    // paddingTop: "0.75rem",
    '& input': {
      borderRadius: '0.375rem',
      width: '100%',
      height: '2.875rem',
      border: 'solid 0.0625rem #929292',
      padding: '0.8125rem 1rem',
    },
  },
  modalPlainBtn: {
    minHeight: '2.875rem',
    borderRadius: '0.375rem',
    border: 'solid 0.0625rem #000',
    backgroundColor: '#fff',
    width: '100%',
    fontFamily: 'inherit',
    fontSize: theme.font.size14,
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '1.43',
    letterSpacing: 'normal',
    textAlign: 'center',
    color: '#000',
  },
  modalInnerItem: {
    padding: '0rem',
    paddingRight: '0.5rem',
  },
  modalInnerItemLast: {
    paddingRight: '0rem',
  },

  nextLine: {
    paddingBottom: 0,
  },
  disabled: {
    background: '#ededed',
    border: '0rem !important',
  },
  divider: {
    height: '0.0625rem',
    background: '#eee',
    margin: '1.2188rem 1rem 1.2188rem 1rem',
  },
  list: {
    display: 'flex',
    alignItems: 'stretch',
    width: '100%',
    'user-select': 'none',
    '-webkit-touch-callout': 'none',
    '-khtml-user-select': 'none',
    '-webkit-tap-highlight-color': 'transparent',
  },
  timeBoxDiv: {
    padding: '0 0.375rem 0 0',
  },
  timeBox: {
    width: '5.3125rem',
    height: '4.375rem',
    background: '#fff',
    borderRadius: '0.375rem',
    padding: '1rem 1.6875rem 1.0625rem 1.75rem',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    border: '0.0625rem solid #eee',
    // outline: 'none',
    color: '#666',
  },
  timeBoxSelected: {
    border: '0.0625rem solid #fff',
    background: '#ea1917',
    fontWeight: 'bold',
    color: '#fff',
  },
  ampm: {
    fontFamily: 'inherit',
    fontSize: theme.font.size12,
    fontWeight: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '1.67',
    letterSpacing: 'normal',
    color: 'inherit',
  },
  time: {
    fontFamily: 'inherit',
    fontSize: theme.font.size14,
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '1.43',
    letterSpacing: 'normal',
    color: 'inherit',
  },
  engineerBoxDiv: {
    padding: '0 0.375rem 0 0',
  },
  engineerBox: {
    width: '9rem',
    height: '5.5rem',
    background: '#fff',
    borderRadius: '0.375rem',
    padding: '1rem 1.6875rem 1.0625rem 1.75rem',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    border: '0.0625rem solid #eee',
    // outline: 'none',
    color: '#666',
  },
  engineerBoxSelected: {
    border: '0.0625rem solid #fff',
    background: '#ea1917',
    fontWeight: 'bold',
    color: '#fff',
  },
  engineerDept: {
    fontFamily: 'inherit',
    fontSize: theme.font.size12,
    fontWeight: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '1.67',
    letterSpacing: 'normal',
    color: '#inherit',
    width: 'max-content',
  },
  engineerName: {
    fontFamily: 'inherit',
    fontSize: theme.font.size14,
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '1.43',
    letterSpacing: 'normal',
    color: 'inherit',
    width: 'max-content',
  },
  carousel: {
    // marginLeft: "-0.625rem",
    // marginRight: "-0.625rem",
  },
  noTime: {
    height: '5.9375rem',
    background: '#f6f6f6',
    borderRadius: '0.375rem',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '1rem 0rem 0.75rem 0rem',
    margin: '0rem 0.625rem',
  },
  noTimeMsg1: {
    fontFamily: 'inherit',
    fontSize: theme.font.size14,
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '1.43',
    letterSpacing: 'normal',
    textAlign: 'center',
    color: '#222',
    paddingBottom: '0.75rem',
  },
  noTimeMsg2: {
    fontFamily: 'inherit',
    fontSize: theme.font.size12,
    fontWeight: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '1.5',
    letterSpacing: 'normal',
    textAlign: 'center',
    color: '#ff3723',
  },
  snackbar: {
    // right: "1rem",
    // left: "1rem",
    '& .MuiPaper-root': {
      padding: '1rem 1.25rem',
    },
    '& .MuiSnackbarContent-message': {
      padding: '0',
      fontSize: theme.font.size14,
    },
  },
  desc: {
    fontSize: theme.font.size14,
    paddingBottom: '0.5rem',
  },
  descUl: {
    margin: '0rem',
    fontSize: theme.font.size12,
    padding: '0 0 0 1rem',
    fontStretch: 'normal',
    fontStyle: 'normal',
    letterSpacing: 'normal',
    lineHeight: 1.5,

    '& ::marker': {
      color: '#666',
      fontSize: theme.font.size12,
    },
    '& li': {
      paddingBottom: '0.5rem',

      '& span.desc-style1': {
        fontWeight: 'bold',
        color: '#008182',
      },
      '& span.desc-style2': {
        fontWeight: 'bold',
        color: '#ea1917',
      },
    },
  },
  descCleaning: {
    fontFamily: 'inherit',
    fontSize: theme.font.size12,
    fontWeight: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '1.5',
    letterSpacing: 'normal',
    textAlign: 'left',
    color: '#000',
  },
  loadingButton: {
    opacity: '0.5',
  },
  cleaningLink: {
    paddingTop: '0.875rem',
    paddingBottom: '1.5rem',
  },
  cleaningLinkSpan: {
    textAlign: 'left',
    cursor: 'pointer',
    fontSize: theme.font.size12,
    textDecoration: 'underline',
    lineHeight: '1.33',
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
  },
  loading: {
    zIndex: '2000',
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    background: '#ffffffd9',
  },
  loadComplete: {
    display: 'none',
  },
  dialogRoot: {
    borderRadius: '0.625rem',
    width: '90%',
    maxWidth: '37.5rem',
  },
  dialogContent: {
    fontFamily: 'inherit',
    fontSize: theme.font.size16,
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '1.38',
    letterSpacing: 'normal',
    textAlign: 'center',
    color: '#000',
    padding: '40px 20px 15px !important',
  },
  dialogFooter: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'cneter',
    padding: '15px',
    '& button': {
      height: '50px',
      width: '50%',
      borderRadius: '6px',
      border: 'solid 1px #ea1917', //"solid 1px #da0f47",
      fontFamily: 'inherit',
      fontSize: theme.font.size14,
      fontWeight: 'bold',
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: '1.43',
      letterSpacing: 'normal',
      textAlign: 'center',
    },
  },
  dialogFooterBtnLeft: {
    background: '#fff',
    color: '#000',
    border: 'solid 0.0625rem #ddd !important',
  },
  dialogFooterBtnRight: {
    background: '#ea1917', //"#da0f47",
    color: '#fff',
  },
  dots: {
    display: 'flex',
    justifyContent: 'center',
    margin: '1rem 0rem 0rem 0rem',
  },
  dot: {
    width: '0.375rem',
    height: '0.375rem',
    borderRadius: '62.4375rem',
    margin: '0rem 2px',
    backgroundColor: '#666',
    // opacity: '0.2',
    transition: 'all, .5s, ease-in-out',
    padding: '0',
    border: 'none',
  },
  dotActive: {
    width: '1.125rem',
    height: '0.375rem',
    background: '#000',
    border: '62.4375rem',
    opacity: '1',
  },
  // 접수시 빠른일정 제공 기능 - 자동선택 ON 25-06
  autoSelectMessage: {
    fontSize: theme.font.size14,
    padding: '0 1rem 0.5rem',
  },
});

const TimeEmblaCarousel = withStyles(styles)((props) => {
  const {
    classes,
    data,
    slides,
    possibleTime,
    selectedVal,
    hirunVal,
    retrieveSeVisitPossibleEngineerSmile,
    scheduleLock,
    ariaLabel,
    isSFDC,
  } = props;

  possibleTime.sort((a, b) => {
    return a.resrvHm - b.resrvHm;
  });

  const [embla, setEmbla] = useState(null);
  const [slide, setSlide] = useState(0);
  const handleTimeClick = (item) => {
    if (embla.clickAllowed()) {
      if (isSFDC) {
        hirunVal
          ? retrieveSeVisitPossibleEngineerSmile(selectedVal.date, item)
          : scheduleLock(item);
      } else {
        retrieveSeVisitPossibleEngineerSmile(selectedVal.date, item);
      }
    }
  };
  const options = { align: 'start', dragFree: true, containScroll: true, startIndex: 0 };
  useEffect(() => {
    if (!possibleTime || !embla) return;
    embla.reInit();
    embla.scrollTo(0);
  }, [possibleTime]);

  const [canScrollPrev, setCanScrollPrev] = useState(false);
  const [canScrollNext, setCanScrollNext] = useState(false);
  const setScrollStatus = () => {
    if (embla) {
      setSlide(embla.selectedScrollSnap());
      setCanScrollPrev(embla.canScrollPrev());
      setCanScrollNext(embla.canScrollNext());
    }
  };
  useEffect(() => {
    if (embla) {
      setCanScrollPrev(embla.canScrollPrev());
      setCanScrollNext(embla.canScrollNext());

      embla.on('select', () => {
        setScrollStatus();
      });
      embla.on('resize', () => {
        setScrollStatus();
      });
    }
  }, [embla, possibleTime]);

  const renderDots = useCallback(() => {
    if (embla) {
      const slide = embla.selectedScrollSnap();
      return (
        <div className={classes.dots}>
          {embla.slideNodes().length === 4
            ? embla.scrollSnapList().map((snap, index) => (
                <button
                  key={`embla-carousel-${index}`}
                  active={index === slide ? 'true' : 'false'}
                  onClick={() => embla.scrollTo(index)}
                  // hidden={index < slide - 3 || index > slide + 3}
                  // role={'button'}
                  className={[
                    classes.dot,
                    index === slide ? classes.dotActive : null,
                  ].join(' ')}
                  aria-label={`${index === slide ? '선택됨,' : ''} ${
                    ariaLabel ? ariaLabel : ''
                  } ${index + 1}번째 슬라이드 보기, ${index + 1} / 4`}
                />
              ))
            : embla.scrollSnapList().map((snap, index) => (
                <button
                  key={`embla-carousel-${index}`}
                  active={index === slide ? 'true' : 'false'}
                  onClick={() => embla.scrollTo(index)}
                  // hidden={index < slide - 2 || index > slide + 2}
                  // role={'button'}
                  className={[
                    classes.dot,
                    index === slide ? classes.dotActive : null,
                  ].join(' ')}
                  aria-label={`${index === slide ? '선택됨,' : ''} ${
                    ariaLabel ? ariaLabel : ''
                  } ${index + 1}번째 슬라이드 보기, ${index + 1} / ${
                    embla.scrollSnapList().length
                  }`}
                />
              ))}
        </div>
      );
    }
    return null;
  }, [embla]);

  return (
    <EmblaCarouselReact emblaRef={setEmbla} options={options}>
      <div className={classes.list}>
        {possibleTime.map((item, index) => (
          <div key={`time-item-${index}`} className={classes.timeBoxDiv}>
            <button
              className={[
                classes.timeBox,
                item.resrvHm === selectedVal.time.resrvHm
                  ? classes.timeBoxSelected
                  : null,
              ].join(' ')}
              onClick={(e) => handleTimeClick(item)}
              title={item.resrvHm === selectedVal.time.resrvHm ? '선택한 시간' : null}
            >
              <div className={classes.ampm}>
                {item.resrvHm >= '1200' ? '오후' : '오전'}
              </div>
              <div className={classes.time}>
                {/* {item.resrvHm.substr(0, 2) > '12'
                  ? item.resrvHm.substr(0, 2) - 12
                  : parseInt(item.resrvHm.substr(0, 2))}
                :{item.resrvHm.substr(2, 2)} */}
                {item.resrvHm.substr(0, 2)}:{item.resrvHm.substr(2, 2)}
              </div>
            </button>
          </div>
        ))}
      </div>
      {renderDots()}
    </EmblaCarouselReact>
  );
});

const EngineerEmblaCarousel = withStyles(styles)((props) => {
  const { classes, possibleEngineer, selectedVal, scheduleLockSmile } = props;
  const [embla, setEmbla] = useState(null);

  const handleEngineerClick = (item) => {
    embla.clickAllowed() && scheduleLockSmile(selectedVal.date, selectedVal.time, item);
  };

  const options = { align: 'start', dragFree: true, containScroll: true, startIndex: 0 };
  useEffect(() => {
    if (!possibleEngineer || !embla) return;
    embla.reInit();
    embla.scrollTo(0);
  }, [possibleEngineer]);
  return (
    <EmblaCarouselReact emblaRef={setEmbla} options={options}>
      <div className={classes.list}>
        {possibleEngineer.map((item, index) => (
          <div key={`engineer-item-${index}`} className={classes.engineerBoxDiv}>
            <button
              className={[
                classes.engineerBox,
                item.seId === selectedVal.engineer.seId
                  ? classes.engineerBoxSelected
                  : null,
              ].join(' ')}
              onClick={(e) => handleEngineerClick(item)}
            >
              <div className={classes.engineerDept}>{item.deptName}</div>
              <div className={classes.engineerName}>{item.seName}</div>
            </button>
          </div>
        ))}
      </div>
    </EmblaCarouselReact>
  );
});
const Options = withStyles(styles)((props) => {
  const {
    classes,
    modalClose,
    data,
    closeCall,
    setCloseDialogOpen,
    setNoDateModalOpen,
    cancelReserve,
    handleAutoSelectMessageChange, // 접수시 빠른일정 제공 기능 - 자동선택 ON 25-06
  } = props;
  // 폭염 T/T 산정을 위한 API변경 요청의 건 25-05
  const { possibleDate, button, modalValue, hirunVal, installType, contactRating } = data;
  const [possibleTime, setPossibleTime] = useState(null);
  const [possibleEngineer, setPossibleEngineer] = useState(null);
  const [selectedVal, setSelectedVal] = useState({ date: {}, time: {}, engineer: {} });
  const [lockId, setLockId] = useState('');
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [engineerSnackbarOpen, setEngineerSnackbarOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const context = useContext(DataContext);

  // 접수시 빠른일정 제공 기능 - 자동선택 ON 25-06
  const [autoSelectTd, setAutoSelectTd] = useState(null);
  useEffect(() => {
    if (autoSelectTd) {
      // 날짜 변환 (2025.06.13)
      const formattedDate = `${autoSelectTd.resrvDt.slice(
        0,
        4
      )}.${autoSelectTd.resrvDt.slice(4, 6)}.${autoSelectTd.resrvDt.slice(6, 8)}`;
      // 시간 변환 (14:00)
      const formattedTime = `${autoSelectTd.resrvHm.slice(
        0,
        2
      )}:${autoSelectTd.resrvHm.slice(2, 4)}`;
      handleAutoSelectMessageChange(
        <>
          가장 빠른 예약 시간은{' '}
          <span style={{ color: '#ea1917', fontWeight: 'bold' }}>
            {formattedDate} {formattedTime}
          </span>{' '}
          입니다.
        </>
      );
    }
  }, [autoSelectTd]);
  // const autoSelect = !context.isSFDC;
  const autoSelect = true;
  useEffect(() => {
    console.log('autoSelect ::::::::', autoSelect);
  }, []);

  let newData = button?.parameters?.modal?.data;
  newData = {
    ...newData,
    installType, // 폭염 T/T 산정을 위한 API변경 요청의 건 25-05
    contactRating, // 폭염 T/T 산정을 위한 API변경 요청의 건 25-05
  };

  useEffect(() => {
    if (closeCall === 'close') {
      if (context.isSFDC) {
        hirunVal ? scheduleUnlockSmile() : scheduleUnlock();
      } else {
        scheduleUnlockSmile();
      }
      // scheduleUnlockSmile()
      modalClose();
    }
  }, [closeCall]);

  async function retrieveSeVisitPossibleTime(dateInfo) {
    setLoading(true);
    console.log('::[new dateinfo]::', dateInfo);
    console.log('기존에 lock되어있으면 해제. @visiblePossibleTime');
    await scheduleUnlock();
    console.log('unlock end');
    setSelectedVal((prev) => ({ ...prev, date: dateInfo, time: {} }));
    try {
      const client = 'lgcom';
      const header = {
        'Content-Type': 'application/json;charset=UTF-8',
        'x-channel': client,
        'x-branch': 'LGEKR',
        'x-country-code': 'kr',
      };
      console.log('!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!');
      console.log('!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!', newData);

      // 무인채널접수 우선T/T제공 (예약변경) 24-05
      const body = {
        zipNo: newData.zipNo,
        zipId: newData.zipId,
        productCode: newData.sfdc_product_code,
        svcType: newData.svc_type, //A:출장접수,B:내방예약,D:가전세척
        deptCode: dateInfo.deptCode,
        reqDt: dateInfo.holiDt,
        custName: newData.user?.user_name, // string	고객이름 	선택	시그니처 T/T
        telNo1_1: newData.telNo1_1,
        telNo1_2: newData.telNo1_2,
        telNo1_3: newData.telNo1_3,
        rcptSympCode: newData.rcptSympCode, // string	증상코드 (1depth)	선택	가전세척 불필요
        rcptSubSympCode: newData.rcptSubSympCode, // string	증상분류코드 (2depth)	선택	가전세척 불필요
        rcptFurtherSubSympCode: newData.rcptFurtherSubSympCode, // string	상세 증상코드 (3depth)	선택	가전세척 불필요
        rcptType: newData.rcpt_type,
        minuteYn: 'Y', // Y: 10분단위 Capa (챗봇은 Y)
        rcptUserId: context.userAgent.deviceType === 'mobile' ? 'WWW4' : 'WWW3',
        installType: newData.installType || '', // 폭염 T/T 산정을 위한 API변경 요청의 건 25-05
        contactRating: newData.contactRating || '', // 폭염 T/T 산정을 위한 API변경 요청의 건 25-05
        // modelCode: newData?.modelCode || ''
      };
      let result = await postExtV2(
        client,
        'sfdc',
        'post',
        '/sfdc/visits/retrieveSeVisitPossibleDateHm',
        header,
        body
      );

      console.log('[retrieveSeVisitPossibleDateHm 시간 검색 결과] body:', body);
      console.log('[retrieve possible time] result:', result.result);
      if (result?.result?.length) {
        // 접수시 빠른일정 제공 기능 - 자동선택 ON 25-06
        autoSelect && scheduleLock(result.result[0], true);
        autoSelect && setAutoSelectTd(result.result[0]);

        setPossibleTime(result.result);
      } else {
        setPossibleTime([]);
        // setSnackbarOpen(true);
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setPossibleTime([]);
      // setSnackbarOpen(true);
      setLoading(false);
    }
  }
  async function retrieveSeVisitPossibleTimeSmile(dateInfo) {
    setLoading(true);
    console.log('[smile] new dateinfo::', dateInfo);
    console.log('기존에 lock되어있으면 해제. @visiblePossibleTimeSmile');
    await scheduleUnlockSmile();
    console.log('unlock end');
    let productCode = '';
    if (context.isSFDC) {
      productCode = newData.sfdc_product_code;
    } else {
      productCode = newData.gscs_product_code;
    }

    setSelectedVal((prev) => ({ ...prev, date: dateInfo, time: {}, engineer: {} }));
    try {
      const body = {
        zipId: newData.zipId,
        productCode: productCode,
        rcptSympCode: newData.rcptSympCode,
        rcptSubSympCode: newData.rcptSubSympCode,
        primiumYn: newData.premium || 'N',
        reqDt: dateInfo.holiDt,
        custName: newData.user?.user_name,
        telNo1_1: newData.telNo1_1,
        telNo1_2: newData.telNo1_2,
        telNo1_3: newData.telNo1_3,
        signatureSmYn: 'Y',
        purpose: newData.purpose, //H: 주거 C: 상업,
        is_hirun: hirunVal ? 'yes' : undefined,
        // installType: newData.installType || '', // 폭염 T/T 산정을 위한 API변경 요청의 건 25-06
        // contactRating: newData.contactRating || '', // 폭염 T/T 산정을 위한 API변경 요청의 건 25-06
      };

      let result = await postSmileExt(
        context,
        'retrieve/retrieveSeVisitScheduleResrvHm',
        body
      );
      console.log('[postSmileExt TIME] param:', body);
      console.log('[postSmileExt TIME] result:', result);

      // 접수시 빠른일정 제공 기능 - 자동선택 ON - 하이런
      const combinedResult = {
        resrvDt: body.reqDt,
        ...result.result[0], // 첫 번째 result 객체 병합
      };
      console.log(combinedResult);

      if (result?.result?.length) {
        // 접수시 빠른일정 제공 기능 - 자동선택 ON 25-06
        autoSelect &&
          retrieveSeVisitPossibleEngineerSmile(dateInfo, result.result[0], true);
        autoSelect && setAutoSelectTd(combinedResult);

        setPossibleTime(result.result);
      } else {
        setPossibleTime([]);
        // setSnackbarOpen(true);
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setPossibleTime([]);
      // setSnackbarOpen(true);
      setLoading(false);
    }
  }
  async function retrieveSeVisitPossibleEngineerSmile(
    dateInfo,
    timeInfo,
    unlockYn = true
  ) {
    setLoading(true);
    console.log('[smile] new timeInfo::', timeInfo, 'dateInfo:', dateInfo);
    unlockYn && (await scheduleUnlockSmile());
    setSelectedVal((prev) => ({ ...prev, time: timeInfo, engineer: {} }));
    try {
      let productCode = '';
      if (context.isSFDC) {
        productCode = newData.sfdc_product_code;
      } else {
        productCode = newData.gscs_product_code;
      }

      const body = {
        zipId: newData.zipId,
        productCode: productCode,
        rcptSympCode: newData.rcptSympCode,
        rcptSubSympCode: newData.rcptSubSympCode,
        primiumYn: newData.premium || 'N',
        reqDt: dateInfo.holiDt, //selectedVal.date.holiDt,
        resrvHm: timeInfo.resrvHm,
        purpose: newData.purpose, //H: 주거 C: 상업,
        is_hirun: hirunVal ? 'yes' : undefined,
        telNo1_1: newData.telNo1_1,
        telNo1_2: newData.telNo1_2,
        telNo1_3: newData.telNo1_3,
        signatureSmYn: 'Y',
        // installType: newData.installType || '', // 폭염 T/T 산정을 위한 API변경 요청의 건 25-06
        // contactRating: newData.contactRating || '', // 폭염 T/T 산정을 위한 API변경 요청의 건 25-06
      };

      let result = await postSmileExt(
        context,
        'retrieve/retrieveSeVisitScheduleList',
        body
      );
      // throw "error"
      console.log('[postSmileExt ENGINEER] param:', body);
      console.log('[postSmileExt ENGINEER] result:', result);
      setLoading(false);
      if (result?.result?.length) {
        // 접수시 빠른일정 제공 기능 - 자동선택 ON 25-06
        autoSelect && scheduleLockSmile(dateInfo, timeInfo, result.result[0], true);
        autoSelect && setAutoSelectTd(result.result[0]);

        setPossibleEngineer(result.result);
      } else {
        setPossibleEngineer([]);
        // setSnackbarOpen(true);
      }
    } catch (error) {
      console.log(error);
      setLoading(false);
      setPossibleEngineer([]);
      // setSnackbarOpen(true);
    }
  }
  async function scheduleLock(timeInfo, unlockYn = true) {
    setLoading(true);

    console.log('=========================[timeInfo]', timeInfo);
    console.log('=========================[newData]', newData);

    if (unlockYn) {
      console.log('[SCHEDULE LOCK::]lockId = ', lockId, lockId.length);
      console.log(
        'New Lock request. so 기존에 lock이 있으면 해제를 먼저한다. @scheduleLock'
      );
      await scheduleUnlock();
    }

    try {
      const client = 'lgcom';
      const header = {
        'Content-Type': 'application/json;charset=UTF-8',
        'x-channel': client,
        'x-branch': 'LGEKR',
        'x-country-code': 'kr',
      };
      let productCode = '';
      if (context.isSFDC) {
        productCode = newData.sfdc_product_code;
      } else {
        productCode = newData.gscs_product_code;
      }
      // 무인채널접수 우선T/T제공 (예약변경) 24-05
      const body = {
        productCode: productCode,
        svcType: newData.svc_type, //A:출장접수,B:내방예약,D:가전세척
        deptCode: timeInfo.deptCode,
        resrvDt: timeInfo.resrvDt,
        resrvHm: timeInfo.resrvHm,
        lockUserId: context.sessionId,
        rcptSympCode: newData.rcptSympCode, // string	증상코드 (1depth)	선택	가전세척 불필요
        rcptSubSympCode: newData.rcptSubSympCode, // string	증상분류코드 (2depth)	선택	가전세척 불필요
        rcptFurtherSubSympCode: newData.rcptFurtherSubSympCode, // string	상세 증상코드 (3depth)	선택	가전세척 불필요
        rcptType: newData.rcpt_type,
        custName: newData.user?.user_name, // string	고객이름 	선택	시그니처 T/T
        telNo1_1: newData.telNo1_1,
        telNo1_2: newData.telNo1_2,
        telNo1_3: newData.telNo1_3,
        minuteYn: 'Y', // Y: 10분단위 Capa (챗봇은 Y)
        modelCode: newData?.modelCode || '', // string	판매 모델 	선택
        installType: newData.installType || '', // 폭염 T/T 산정을 위한 API변경 요청의 건 25-05
        contactRating: newData.contactRating || '', // 폭염 T/T 산정을 위한 API변경 요청의 건 25-05
      };
      let result = await postExtV2(
        client,
        'sfdc',
        'post',
        '/sfdc/visits/lockSchedule',
        header,
        body
      );
      console.log('[락스케줄 SCHEDULE LOCK] param:', body);
      console.log('[SCHEDULE LOCK] result:', result);
      console.log('[SCHEDULE LOCK] LockId:', result.result.lockId);
      if (result?.result?.successYn === 'Y') {
        setSelectedVal((prev) => ({ ...prev, time: timeInfo }));
        console.log('[SCHEDULE LOCK] SUCCESS');
        setLockId(result.result.lockId);
      } else {
        console.log('[SCHEDULE LOCK] FAIL');
        setSnackbarOpen(true);
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
      setSnackbarOpen(true);
    }
  }
  async function scheduleUnlock() {
    console.log('[SCHEDULE UNLOCK] START------');
    if (!lockId.length) {
      console.log('[SCHEDULE UNLOCK]no lockId to unlock');
      return;
    }

    try {
      const client = 'lgcom';
      const header = {
        'Content-Type': 'application/json;charset=UTF-8',
        'x-channel': client,
        'x-branch': 'LGEKR',
        'x-country-code': 'kr',
      };
      const body = {
        svcType: newData.svc_type, //A:출장접수,B:내방예약,D:가전세척
        lockId: lockId,
      };
      let result = await postExtV2(
        client,
        'sfdc',
        'post',
        '/sfdc/visits/unLockSchedule',
        header,
        body
      );
      console.log('[SCHEDULE UNLOCK] param:', body);
      console.log('[SCHEDULE UNLOCK] result:', result);
      result.result && result.result.successYn === 'Y' && setLockId('');
    } catch (error) {
      console.log(error);
      console.log('[SCHEDULE UNLOCK] FAIL');
    }
  }
  async function scheduleLockSmile(dateInfo, timeInfo, engineerInfo, unlockYn = true) {
    setLoading(true);

    console.log('>>>', lockId, lockId.length);
    unlockYn && (await scheduleUnlockSmile());
    try {
      const body = {
        mode: 'LOCK',
        lockUserId:
          context.sessionId.length > 16
            ? context.sessionId.substring(0, 15)
            : context.sessionId,
        // "lockUserId": context.sessionId,
        resrvDt: dateInfo.holiDt,
        resrvHm: engineerInfo.resrvHm,
        resrvSeq: engineerInfo.resrvSeq,
        seId: engineerInfo.seId,
        is_hirun: hirunVal ? 'yes' : undefined,
        // installType: newData?.installType || '', // 폭염 T/T 산정을 위한 API변경 요청의 건 25-06
        // contactRating: newData?.contactRating || '', // 폭염 T/T 산정을 위한 API변경 요청의 건 25-06
      };

      let result = await postSmileExt(context, 'cud/lockSchedule', body);
      // throw(" smail engineer lock fail")
      console.log('[postSmileExt LOCK] praram:', body);
      console.log('[postSmileExt LOCK] result:', result);
      setLoading(false);
      if (result.result && result.result.successYn === 'Y') {
        // console.log("shcedule lock success!!")
        setLockId(body.lockUserId);
        setSelectedVal((prev) => ({ ...prev, engineer: engineerInfo }));
      } else {
        console.log('lock 실패하였습니다.');
        setEngineerSnackbarOpen(true);
      }
    } catch (error) {
      console.log(error);
      setLoading(false);
      setEngineerSnackbarOpen(true);
    }
  }
  async function scheduleUnlockSmile() {
    console.log('unlock request smile');
    if (!lockId.length) {
      console.log('no lockId to unlock');
      return;
    }

    try {
      const body = {
        mode: 'UNLOCK',
        lockUserId: lockId,
        is_hirun: hirunVal ? 'yes' : undefined,
      };

      let result = await postSmileExt(context, 'cud/lockSchedule', body);
      console.log('[postSmileExt UNLOCK] praram:', body);
      console.log('[postSmileExt UNLOCK] result:', result);
      result.result && result.result.successYn === 'Y' && setLockId('');
    } catch (error) {
      console.log(error);
    }
  }
  async function retrieveEngTimeCheck(requestData) {
    try {
      const body = {
        seId: requestData.seId,
        resrvSeq: requestData.resrvSeq,
        resrvDt: requestData.promDt,
        resrvHm: requestData.promHm,
        lockUserId: lockId,
        is_hirun: hirunVal ? 'yes' : undefined,
        // installType: newData?.installType || '', // 폭염 T/T 산정을 위한 API변경 요청의 건 25-06
        // contactRating: newData?.contactRating || '', // 폭염 T/T 산정을 위한 API변경 요청의 건 25-06
      };
      console.log('[postSmileExt ENG CHECK] praram:', body);
      let result = await postSmileExt(context, 'retrieve/retrieveEngTimeCheck', body);
      console.log('[postSmileExt ENG CHECK] result:', result, result.result?.cnt > 0);
      if (result.result?.cnt > 0) {
        submit(requestData);
      } else {
        setEngineerSnackbarOpen(true);
        throw 'RetrieveEngTimeCheckFalse';
      }
    } catch (error) {
      console.log('ERROR', error);
      setLoading(false);
    }
  }
  const handleComplete = (e) => {
    console.log('[selectedVal]', selectedVal);
    console.log('[lockId]', lockId);
    console.log('[hirunVal]', hirunVal);
    setLoading(true);

    try {
      if (context.isSFDC) {
        if (hirunVal) {
          const requestData = {}; //orgData.meta;
          const telNum = newData.user?.phone_number;
          var tel1 = telNum.length >= 3 ? telNum.substr(0, 3) : '';
          var tel2 =
            telNum.length === 10
              ? telNum.substr(3, 3)
              : telNum.length === 11
              ? telNum.substr(3, 4)
              : '';
          var tel3 = telNum.length >= 4 ? telNum.substr(telNum.length - 4, 4) : '';

          requestData.svcType = newData.svc_type;
          requestData.productCode = newData.sfdc_product_code;
          requestData.custName = newData.user?.user_name;

          requestData.bypass_br = 'change';
          requestData.reReqDt = selectedVal.date.holiDt;
          requestData.reReqHm = selectedVal.time.resrvHm;
          requestData.zipId = newData.zipId;
          requestData.promHm = selectedVal.time.resrvHm;
          requestData.promDt = selectedVal.date.holiDt;
          requestData.seId = selectedVal.engineer.seId;
          requestData.resrvSeq = selectedVal.engineer.resrvSeq;

          requestData.warrantyType = '';
          requestData.custReqDt = selectedVal.date.holiDt;
          requestData.custReqHm = selectedVal.time.resrvHm;
          requestData.firstPromDt = selectedVal.date.holiDt;
          requestData.firstPromHm = selectedVal.time.resrvHm;
          requestData.smsType = '';

          requestData.telNo1_1 = tel1; //orgData.meta?.tel1 || orgData.meta?.telNo11;
          requestData.telNo1_2 = tel2; //orgData.meta?.tel2 || orgData.meta?.telNo12;
          requestData.telNo1_3 = tel3; //orgData.meta?.tel3 || orgData.meta?.telNo13;
          requestData.rcptUserId =
            context.userAgent.deviceType === 'mobile' ? 'WWW4' : 'WWW3';
          requestData.aniTelNo = telNum;

          requestData.emailYn = 'N';
          requestData.is_hirun = hirunVal ? 'yes' : undefined;
          requestData.cancelUserId = requestData.rcptUserId;
          requestData.deptCode = selectedVal.engineer.deptCode;

          // requestData.installType = newData?.installType ? newData?.installType : ''; // 폭염 T/T 산정을 위한 API변경 요청의 건 25-06
          // requestData.contactRating = newData?.contactRating
          //   ? newData?.contactRating
          //   : ''; // 폭염 T/T 산정을 위한 API변경 요청의 건 25-06
          retrieveEngTimeCheck(requestData);
        } else {
          const requestData = {
            bypass_br: 'change',
            svcType: newData.svc_type, //A:출장접수,B:내방예약,D:가전세척
            rcptNo: newData.rcptNo,
            reReqDt: selectedVal.date.holiDt,
            reReqHm: selectedVal.time.resrvHm,
            lockId: lockId,
            custName: newData.user?.user_name || '',
            installType: newData.installType || '', // 폭염 T/T 산정을 위한 API변경 요청의 건 25-05
            contactRating: newData.contactRating || '', // 폭염 T/T 산정을 위한 API변경 요청의 건 25-05
          };
          submit(requestData);
        }
      } else {
        const requestData = {}; //orgData.meta;
        const telNum = newData.user?.phone_number;
        var tel1 = telNum.length >= 3 ? telNum.substr(0, 3) : '';
        var tel2 =
          telNum.length === 10
            ? telNum.substr(3, 3)
            : telNum.length === 11
            ? telNum.substr(3, 4)
            : '';
        var tel3 = telNum.length >= 4 ? telNum.substr(telNum.length - 4, 4) : '';

        requestData.svcType = newData.svc_type;
        requestData.productCode = newData.gscs_product_code;
        requestData.custName = newData.user?.user_name;

        requestData.bypass_br = 'change';
        requestData.reReqDt = selectedVal.date.holiDt;
        requestData.reReqHm = selectedVal.time.resrvHm;
        requestData.zipId = newData.zipId;
        requestData.promHm = selectedVal.time.resrvHm;
        requestData.promDt = selectedVal.date.holiDt;
        requestData.seId = selectedVal.engineer.seId;
        requestData.resrvSeq = selectedVal.engineer.resrvSeq;

        requestData.warrantyType = '';
        requestData.custReqDt = selectedVal.date.holiDt;
        requestData.custReqHm = selectedVal.time.resrvHm;
        requestData.firstPromDt = selectedVal.date.holiDt;
        requestData.firstPromHm = selectedVal.time.resrvHm;
        requestData.smsType = '';

        requestData.telNo1_1 = tel1; //orgData.meta?.tel1 || orgData.meta?.telNo11;
        requestData.telNo1_2 = tel2; //orgData.meta?.tel2 || orgData.meta?.telNo12;
        requestData.telNo1_3 = tel3; //orgData.meta?.tel3 || orgData.meta?.telNo13;
        requestData.rcptUserId =
          context.userAgent.deviceType === 'mobile' ? 'WWW4' : 'WWW3';
        requestData.aniTelNo = telNum;

        requestData.emailYn = 'N';
        requestData.is_hirun = hirunVal ? 'yes' : undefined;
        requestData.cancelUserId = requestData.rcptUserId;
        requestData.deptCode = selectedVal.engineer.deptCode;

        // requestData.installType = newData?.installType ? newData?.installType : ''; // 폭염 T/T 산정을 위한 API변경 요청의 건 25-06
        // requestData.contactRating = newData?.contactRating ? newData?.contactRating : ''; // 폭염 T/T 산정을 위한 API변경 요청의 건 25-06
        retrieveEngTimeCheck(requestData);
      }
    } catch (error) {
      console.log('ERROR', error);
      setNoDateModalOpen(true);
      setLoading(false);
    }
  };

  const submit = (requestData) => {
    console.log('[SUBMIT Request Param]', requestData);
    const defaultParameters = button?.parameters?.parameters;
    const defaultExpect = button?.parameters?.expect;
    const modalData = button?.parameters?.modal?.data;
    context.request(
      context,
      defaultParameters?.speech || '예약완료',
      'button',
      {
        ...defaultParameters,
        ...modalData,
        ...requestData,
        bypass_br: 'change',
      },
      defaultExpect || {
        mode: 'bypass',
        intent: 'THQ_BOOK_CHANGE',
      }
    );

    modalClose();
  };

  const goToPrevModal = () => {
    // hirunVal? scheduleUnlockSmile(): scheduleUnlock()
    scheduleUnlockSmile();
    modalClose();
  };

  const handleClickCleaningLink = () => {
    const url = 'https://www.lge.co.kr/lg-best-care/home-appliance-cleaning?chatbot=y';
    openLink(context, 'external', url);
  };

  return (
    <Fragment>
      <Grid container className={classes.modalGridContainer}>
        {/* Calendar */}
        <Grid
          item
          xs={12}
          className={[classes.modalGridItemLabel, classes.modalGridItemLabelFirst].join(
            ' '
          )}
        >
          {/* <WeekView possibleDate={testData} getPossibleTime={retrieveSeVisitPossibleTime}/> */}
          {possibleDate && (
            <WeekView
              possibleDate={possibleDate}
              getPossibleTime={
                context.isSFDC
                  ? hirunVal
                    ? retrieveSeVisitPossibleTimeSmile
                    : retrieveSeVisitPossibleTime
                  : retrieveSeVisitPossibleTimeSmile
              }
              // getPossibleTime = {retrieveSeVisitPossibleTimeSmile}
              autoSelect={autoSelect}
            />
          )}
        </Grid>
      </Grid>
      {Object.keys(selectedVal.date).length != 0 && (
        <Divider classes={{ root: classes.divider }} />
      )}

      {/* Time */}
      {Object.keys(selectedVal.date).length != 0 && (
        <Grid container className={classes.modalGridContainer}>
          <Grid item xs={12} className={classes.modalGridItemLabel}>
            {context.isSFDC ? (
              hirunVal ? (
                <div className={classes.modalLabel}>시간선택</div>
              ) : (
                <Fragment>
                  <div className={classes.modalLabel}>예약 가능 시간대</div>
                  {/* <div className={classes.modalLabelDesc}>
                    시간대를 선택하시면 가장 빠른 시간을 안내해 드려요.
                  </div> */}
                </Fragment>
              )
            ) : (
              <div className={classes.modalLabel}>시간선택</div>
            )}
            <div className={classes.carousel}>
              {possibleTime && possibleTime.length ? (
                <TimeEmblaCarousel
                  possibleTime={possibleTime}
                  selectedVal={selectedVal}
                  hirunVal={hirunVal}
                  // scheduleLock={hirunVal? retrieveSeVisitPossibleEngineerSmile: scheduleLock}
                  retrieveSeVisitPossibleEngineerSmile={
                    retrieveSeVisitPossibleEngineerSmile
                  }
                  scheduleLock={scheduleLock}
                  isSFDC={context.isSFDC}
                ></TimeEmblaCarousel>
              ) : (
                !loading && (
                  <div className={classes.noTime}>
                    <div className={classes.noTimeMsg1}>죄송합니다.</div>
                    <div className={classes.noTimeMsg2}>
                      선택하신 날짜에 서비스 가능한 시간을 찾지 못했습니다.
                      <br />
                      다른 예약일자를 선택해 주세요.
                    </div>
                  </div>
                )
              )}
            </div>
          </Grid>
        </Grid>
      )}
      <Divider classes={{ root: classes.divider }} />
      {Object.keys(selectedVal.date).length != 0 &&
        Object.keys(selectedVal.time).length != 0 &&
        (context.isSFDC === false || hirunVal) && (
          <Fragment>
            <Grid container className={classes.modalGridContainer}>
              {/* Engineer */}
              <Grid item xs={12} className={classes.modalGridItemLabel}>
                <div className={[classes.modalLabel, classes.terms].join(' ')}>
                  담당 서비스매니저
                </div>
                <div className={classes.carousel}>
                  {possibleEngineer && possibleEngineer.length ? (
                    <EngineerEmblaCarousel
                      possibleEngineer={possibleEngineer}
                      selectedVal={selectedVal}
                      scheduleLockSmile={scheduleLockSmile}
                    />
                  ) : (
                    <div className={classes.noTime}>
                      <div className={classes.noTimeMsg1}>죄송합니다.</div>
                      <div className={classes.noTimeMsg2}>
                        선택하신 시간에 배치 가능한 매니저를 찾지 못했습니다.
                        <br />
                        다른 예약일시를 선택해 주세요.
                      </div>
                    </div>
                  )}
                </div>
              </Grid>
              {/* Engineer */}
            </Grid>
            <Divider classes={{ root: classes.divider }} />
          </Fragment>
        )}
      <Grid container className={classes.modalGridContainer}>
        <Grid
          item
          xs={12}
          className={[classes.modalGridItemLabel, classes.modalGridItemLabelFirst].join(
            ' '
          )}
        >
          <div className={[classes.modalLabel, classes.desc].join(' ')}>
            {newData.rcptSympName === '세척서비스'
              ? 'LG가전 세척 안내'
              : '출장 점검료 안내'}
          </div>
          {newData.rcptSympName === '세척서비스' ? (
            <Fragment>
              <div className={classes.descCleaning}>
                기본적인 제품성능점검 및 세정, 살균 탈취 등의 서비스를 제공하며, 자세한
                비용은 서비스매니저가 제품 점검 후 안내 가능합니다. (일부 소모품 교체 시
                추가 비용 발생될 수 있음)
              </div>
              <div className={classes.cleaningLink}>
                <span
                  className={classes.cleaningLinkSpan}
                  onClick={handleClickCleaningLink}
                >
                  {' '}
                  가전 세척 비용 확인하기 &gt;{' '}
                </span>
              </div>
            </Fragment>
          ) : (
            <ul className={classes.descUl}>
              <li>
                <span class="desc-style1">챗봇에서는 1건씩만 예약</span>할 수 있습니다.
                제품이 2대 이상인 경우 고객센터(1544-7777)로 문의하시면, 여러 제품을 한
                번에 접수하실 수 있도록 상담사가 도와드리겠습니다.
              </li>
              <li>
                무상 보증기간이 지난 경우 출장비가 발생하며, 점검 내용에 따라 수리비와
                부품비가 추가로 발생할 수 있습니다.
                <br />
                단, 평일 18시 이후, 주말/공휴일에는 저녁/휴일 요금이 적용됩니다.
                <br />
                1&#41; 일반 기간(1~5월, 9~12월) : 기본 25,000원, 저녁/휴일 30,000원
                <br />
                2&#41; 여름 성수기(6~8월) : 기본 30,000원, 저녁/휴일 35,000원
                <br /> - 대상 제품 : 시스템에어컨, 에어컨, 냉장고, 김치냉장고
              </li>
              <li>
                <span class="desc-style2">
                  무상 보증기간이 지나지 않았더라도, 제품 고장이 아니거나 고객의 사용상
                  부주의로 인한 수리인 경우 서비스 요금이 부과
                </span>
                됩니다.
              </li>
              <li>
                서비스 요금은 카드 또는 현금으로만 결제하실 수 있으며,{' '}
                <span class="desc-style2">수리 당일 현장에서 결제</span>해 주셔야만 수리
                진행이 가능합니다.
              </li>
              <li>
                예약 시간은 서비스매니저 배정 상황에 따라 변경될 수 있으며, 예약이
                확정되면 고객님께 다시 정확한 일정을 안내해 드립니다.
              </li>
            </ul>
          )}
        </Grid>
        {/* {(newData.rcptSympName.rcptSympName!=="세척서비스") &&
        <Grid item xs={12} className={classes.modalGridItemLabel}>
          <div className={[classes.modalLabel, classes.desc].join(" ")}>출장 기타 안내</div>
          <ul className={classes.descUl}>
            <li>
            일부 도서[섬] 지역의 경우 관련 법령에 따라 일부 서비스[용접 수리 및 냉매 주입 등]가 제한될 수 있습니다.
            </li>
          </ul>
        </Grid>
        } */}
      </Grid>
      <Snackbar
        className={classes.snackbar}
        open={snackbarOpen}
        autoHideDuration={3000}
        message={
          '선택하신 시간은 예약할 수 없습니다. 다른 시간을 선택해 주시거나 잠시 후에 다시 시도해 주세요.'
        }
        onClose={() => {
          setSnackbarOpen(false);
        }}
      />
      <Snackbar
        className={classes.snackbar}
        open={engineerSnackbarOpen}
        autoHideDuration={3000}
        message={
          '선택하신 엔지니어는 예약할 수 없습니다. 다른 서비스 매니저를 선택하시거나 다른 시간을 선택해 주세요.'
        }
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        onClose={() => {
          setEngineerSnackbarOpen(false);
        }}
      />
      {/* footer button */}
      <Grid container className={classes.modalFooter}>
        <Grid item xs={6} className={classes.modalButtonLeft}>
          <button
            type="button"
            className={classes.modalButton}
            onClick={() => setCloseDialogOpen(true)}
          >
            취소
          </button>
        </Grid>
        <Grid item xs={6} className={classes.modalButtonRight}>
          <button
            className={[
              classes.modalButton,
              classes.modalButtonStrong,
              loading ||
              Object.keys(selectedVal.date).length == 0 ||
              Object.keys(selectedVal.time).length == 0 ||
              ((context.isSFDC === false || hirunVal) &&
                Object.keys(selectedVal.engineer).length == 0)
                ? classes.loadingButton
                : null,
            ].join(' ')}
            disabled={
              loading ||
              Object.keys(selectedVal.date).length == 0 ||
              Object.keys(selectedVal.time).length == 0 ||
              ((context.isSFDC === false || hirunVal) &&
                Object.keys(selectedVal.engineer).length == 0)
                ? 'disabled'
                : ''
            }
            onClick={handleComplete}
          >
            예약완료
          </button>
        </Grid>
      </Grid>
      <div className={[classes.loading, !loading && classes.loadComplete].join(' ')}>
        <Loading height="80vh" />
      </div>
    </Fragment>
  );
});

function ReserveUpdate(props) {
  const { classes, modalOpen, modalClose, possibleDate, data, completeClose, hirunVal } =
    props;
  // 폭염 T/T 산정을 위한 API변경 요청의 건 25-05
  const { modalValue, button, installType, contactRating } = data || {
    modalValue: null,
    button: null,
    installType: '', // 폭염 T/T 산정을 위한 API변경 요청의 건 25-05
    contactRating: '', // 폭염 T/T 산정을 위한 API변경 요청의 건 25-05
  };
  const [noDateModalOpen, setNoDateModalOpen] = useState(false);
  const context = useContext(DataContext);
  // console.log("::::::::::reserve update::::::[hirunVal]",hirunVal )
  // console.log('::::::::::reserve update::::::[button]', button);
  // console.log('::::::::::reserve update::::::[possibleDate]', possibleDate, modalOpen);
  const newData = button?.parameters?.modal?.data;
  const userData = button?.parameters?.modal?.data?.user;
  const modalRef = useRef();

  // console.log('::::::::::reserve update::::::[newData]', newData);
  // console.log('::::::::::reserve update::::::[installType]', installType);
  // console.log('::::::::::reserve update::::::[contactRating]', contactRating);

  // 접수시 빠른일정 제공 기능 - 자동선택 ON 25-06
  const [autoSelectMessage, setAutoSelectMessage] = useState('');
  const handleAutoSelectMessageChange = (newMessage) => {
    setAutoSelectMessage(newMessage);
  };

  useEffect(() => {
    if (modalOpen) {
      // 웹접근성 - 모달팝업 포커스 25-01
      const { current: modalElement } = modalRef;
      window.setTimeout(() => {
        modalElement.focus();
      });
    }
  }, [modalOpen]);

  useEffect(() => {
    // no date modal open
    if (
      ((!possibleDate || !possibleDate.length) && modalOpen) ||
      (possibleDate?.error && !possibleDate.length)
    ) {
      setNoDateModalOpen(true);
      modalClose();
    }
  }, [possibleDate, modalOpen]);

  const [closeCall, setCloseCall] = useState('');
  const cancelReserve = () => {
    const defaultParameters = button?.parameters?.parameters;
    const defaultExpect = button?.parameters?.expect;
    let byPassBrObj = { bypass_br: 'cancel' };
    context.request(
      context,
      defaultParameters?.speech || '그만하기',
      'button',
      {
        ...defaultParameters,
        ...byPassBrObj,
        user_name: userData.user_name,
        rcptNo: newData.rcptNo,
      },
      defaultExpect || {
        mode: 'bypass',
        intent: 'THQ_BOOK_CHANGE',
      }
    );
    setCloseCall('close'); //unlock
    setCloseDialogOpen(false); //close dialog close
    modalClose();
  };
  const [closeDialogOpen, setCloseDialogOpen] = useState(false);

  return createPortal(
    <div className={classes.root}>
      {/* <Drawer anchor="bottom" open={modalOpen} classes={{ paper: classes.drawerFrame }}> */}
      {modalOpen && (
        <div className={classes.drawerContainer}>
          <div className={classes.dialogContainerBackdrop} aria-hidden="true"></div>
          <div className={classes.drawerFrame}>
            <div className={classes.drawerRoot}>
              <div className={classes.drawerHeaderCloseTop}>
                <div className={classes.titleCloseTop} ref={modalRef} tabIndex="0">
                  날짜와 시간을 선택해 주세요.
                </div>
                <button
                  className={classes.closeTop}
                  onClick={() => setCloseDialogOpen(true)}
                >
                  <img src={Close} className={classes.arrowDown} alt="닫기" />
                </button>
              </div>
              {/* 접수시 빠른일정 제공 기능 - 자동선택 ON 25-06 */}
              <div className={classes.autoSelectMessage}>{autoSelectMessage}</div>

              <Divider classes={{ root: classes.dividerTitle }} />
              <div className={classes.componentWrapper}>
                <Options
                  data={{
                    possibleDate: possibleDate,
                    button: button,
                    modalValue: modalValue,
                    hirunVal: hirunVal,
                    nextModalOpen: modalOpen,
                    installType: installType, // 폭염 T/T 산정을 위한 API변경 요청의 건 25-05
                    contactRating: contactRating, // 폭염 T/T 산정을 위한 API변경 요청의 건 25-05
                  }}
                  modalClose={modalClose}
                  closeCall={closeCall}
                  cancelReserve={cancelReserve}
                  setNoDateModalOpen={setNoDateModalOpen}
                  setCloseDialogOpen={setCloseDialogOpen}
                  handleAutoSelectMessageChange={handleAutoSelectMessageChange} // 접수시 빠른일정 제공 기능 - 자동선택 ON 25-06
                />
              </div>
            </div>
          </div>
        </div>
      )}
      {/* </Drawer> */}

      <Dialog
        open={closeDialogOpen}
        onClose={() => setCloseDialogOpen(false)}
        classes={{ paper: classes.dialogRoot }}
      >
        <DialogContent classes={{ root: classes.dialogContent }}>
          지금 종료하시면 입력하신 <br />
          정보가 사라져요. 그만하시겠어요?
        </DialogContent>
        <DialogActions classes={{ root: classes.dialogFooter }}>
          <button
            className={classes.dialogFooterBtnLeft}
            onClick={() => cancelReserve('all')}
          >
            그만하기
          </button>
          <button
            className={classes.dialogFooterBtnRight}
            onClick={() => setCloseDialogOpen(false)}
            autoFocus
          >
            계속하기
          </button>
        </DialogActions>
      </Dialog>
      <ReserveNoDate
        modalOpen={noDateModalOpen}
        modalClose={() => setNoDateModalOpen(false)}
        data={{
          possibleDate: possibleDate,
          button: button,
          modalValue: modalValue,
          hirunVal: hirunVal,
          nextModalOpen: modalOpen,
        }}
        completeClose={completeClose}
        closeCall={closeCall}
        cancelReserve={() => cancelReserve('all')}
      />
    </div>,
    document.getElementById('modal')
  );
}
export default withStyles(styles)(ReserveUpdate);
